// extracted by mini-css-extract-plugin
export default {"graphTitle":"graph-bars_graphTitle__IsVs5","loaderWrapper":"graph-bars_loaderWrapper__rEP2C"};